import React from 'react';

/**
 * TasksCompletedBadge
 * ------------------------------------------------------------------
 * Compact "75% Tasks Completed" chip with progress bar + count,
 * shown in the My Tasks tab actions row (Figma 40004381-6012).
 */
const TasksCompletedBadge = ({
  percent = 75,
  done = 12,
  total = 15,
  className = '',
}) => (
  <div className={`tasks-completed-badge ${className}`.trim()}>
    <div className="tasks-completed-badge__content">
      <div className="tasks-completed-badge__main">
        <p className="tasks-completed-badge__label">{percent}% Tasks Completed</p>
        <div
          className="tasks-completed-badge__track"
          role="progressbar"
          aria-valuenow={done}
          aria-valuemin={0}
          aria-valuemax={total}
          aria-label={`${percent}% tasks completed`}
        >
          <div
            className="tasks-completed-badge__fill"
            style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
          />
        </div>
      </div>
      <span className="tasks-completed-badge__count">
        {done}/{total}
      </span>
    </div>
  </div>
);

export default TasksCompletedBadge;
